module.exports = __webpack_public_path__ + "img/newLogo2.e106d5ac.png";